module.exports = __webpack_public_path__ + "img/POL-B.7e4acebe.png";